export const GET_AGREEMENTS_START='GET_AGREEMENTS_START';
export const GET_AGREEMENTS_SUCCESS='GET_AGREEMENTS_SUCCESS';
export const GET_AGREEMENTS_FAIL='GET_AGREEMENTS_FAIL';

export const UPDATE_AGREEMENT_START='UPDATE_AGREEMENT_START';
export const UPDATE_AGREEMENT_SUCCESS='UPDATE_AGREEMENT_SUCCESS';
export const UPDATE_AGREEMENT_FAIL='UPDATE_AGREEMENT_FAIL';

export const TOGGLE_UPDATE_AGREEMENT_MODAL='TOGGLE_UPDATE_AGREEMENT_MODAL';